import React from "react";
import { useI18n, LANGS } from "@/context/I18nContext";
import { ChevronDown } from "lucide-react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

const FLAG = { ja: "jp", en: "us", pt: "br" };

export function LanguageSelect({ variant = "light", className = "" }) {
  const { lang, setLang } = useI18n();
  const current = LANGS.find((l) => l.code === lang);
  const triggerCls =
    variant === "dark"
      ? "border-white/15 hover:border-white/30 text-gray-200"
      : "border-border hover:bg-muted text-foreground";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={`inline-flex items-center gap-2 px-2.5 py-1.5 rounded-md border text-xs transition-colors focus:outline-none ${triggerCls} ${className}`}
          data-testid="lang-select-trigger"
        >
          <img src={`https://flagcdn.com/w20/${FLAG[lang]}.png`} alt="" className="w-5 h-auto rounded-[2px]" />
          <span>{current?.label}</span>
          <ChevronDown className="w-3.5 h-3.5 opacity-70" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[150px]">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            className="gap-2 cursor-pointer"
            data-testid={`lang-select-${l.code}`}
          >
            <img src={`https://flagcdn.com/w20/${FLAG[l.code]}.png`} alt="" className="w-5 h-auto rounded-[2px]" />
            <span>{l.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
